var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.partner),function(item){return _c('div',{key:item.id,staticClass:"box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('div',[_c('el-image',{attrs:{"src":item.imgUrl,"z-index":1}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }